var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 119,
    viewBox: "0 0 103 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 58.3232,
    r: 51.5,
    transform: "rotate(90 51.5 58.3232)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4563 93.9542C50.6929 93.9521 50.0758 93.3315 50.0779 92.5681L50.2624 25.5824C50.2645 24.8191 50.8851 24.2019 51.6485 24.204C52.4119 24.2061 53.029 24.8267 53.0269 25.5901L52.8424 92.5757C52.8403 93.3391 52.2197 93.9563 51.4563 93.9542Z",
    fill: "#173930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0226 58.0094C86.5624 58.5492 86.5624 59.4244 86.0226 59.9642L52.4375 93.5493C51.8977 94.0891 51.0225 94.0891 50.4827 93.5493L17.0822 60.1488C16.5424 59.609 16.5424 58.7338 17.0822 58.1939C17.622 57.6541 18.4972 57.6541 19.037 58.194L51.4601 90.6171L84.0678 58.0094C84.6076 57.4696 85.4828 57.4696 86.0226 58.0094Z",
    fill: "#173930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.f12b40427942670b221f5bb24b3c6f90.svg";
export { ForwardRef as ReactComponent };